module.exports = __webpack_public_path__ + "assets/images/outfit-04.49ace39d43a177760e74d43c291b426e.svg";